var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout"}},[_c('navbar'),(!_vm.isNavbarCollapseOpen)?_c('div',[_c('router-view',{key:_vm.currentKey,on:{"changeComponentKey":_vm.changeComponentKey}}),(!_vm.storeMode)?_c('app-footer'):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }